module.exports = __webpack_public_path__ + "assets/Icona_piatti_freddi_menu_laterale.2d0f62ab.svg";